import React from 'react';
import { ShimmerSkeleton } from './LoadingShimmer.style';

const LoadingShimmer = () => {
    return <ShimmerSkeleton />;
};

export default LoadingShimmer;
